<template>
  <cash :cashList="cashList" :cashStatus="cashStatus" :currentSeckill="currentSeckill" @gotoGame="gotoGame">
    <date-tab
      slot="date"
      :seckillList="seckillList"
      :currentSeckill="currentSeckill"
      @getCurrentSeckill="changeSeckillDate"
    ></date-tab>
  </cash>
</template>

<script>
import Cash from '@this/components/List/Cash';
import DateTab from '@this/components/List/DateTab';
import { mapState, mapActions } from 'vuex';
export default {
  created() {
    this.getSeckillList();
  },
  computed: {
    ...mapState('cash', ['seckillList', 'currentSeckill', 'cashList', 'cashStatus']),
  },
  methods: {
    ...mapActions('cash', ['getSeckillList', 'getCurrentSeckill', 'seckillCountDown']),
    ...mapActions('goto', ['gotoGame']),
    async changeSeckillDate(item) {
      await this.getCurrentSeckill(item.date);
    },
  },
  components: {
    Cash,
    DateTab,
  },
};
</script>
